import React from "react"
import { Redirect } from "react-router-dom"
import MetaTags from "react-meta-tags"
import PasswordChangeModal from "../Dashboard/PasswordChangeModal"

const ChangePasswordRequired = () => {
  const authUser = sessionStorage.getItem("authUser")
  if (!authUser) return <Redirect to="/login" />
  if (localStorage.getItem("isChangePasswordRequired") !== "true") return <Redirect to="/dashboard" />

  return (
    <React.Fragment>
      <MetaTags>
        <title>Office portal - Realty Space</title>
      </MetaTags>
      <div className="rs-db-pw-page" />
      <PasswordChangeModal isOpen />
    </React.Fragment>
  )
}

export default ChangePasswordRequired
